<template>
    <button :type="type" :class="['primary-btn text-center mb-4', wrapperClass]" @click="emitClickEvent">
        {{ text }}
    </button>
</template>

<script>

export default {
  name: 'PrimaryButton',
  props: {
    type: {
        type: String,
        default: "button"
    },
    text: {
        type: String,
        default: ""
    },
    wrapperClass: {
        type: String,
        default: ""
    }
  },
  methods: {
    emitClickEvent() {
      this.$emit('click')
    }
  }
 
}
</script>

<style lang="scss" scoped>
@import "./styles.scss";
</style>